export default __webpack_public_path__ + "static/media/star-favorite-active.7b6be484.svg";